import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { BYPASS_INTERCEPTOR } from '@connect-services/client/interceptors/http-errors.interceptor';
import { TranslateService } from '@connect-services/client/services/translate.service';

export function httpAcceptLanguageInterceptor(
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
    const translocoService = inject(TranslateService);

    const requestHeaderLanguage = request.clone({
        headers: request.headers.set('Accept-Language', translocoService.getCurrentLang()),
    });

    if (
        request.context.has(BYPASS_INTERCEPTOR) &&
        request.context.get(BYPASS_INTERCEPTOR).includes('httpAcceptLanguageInterceptor')
    ) {
        return next(request);
    }

    return next(requestHeaderLanguage);
}
